<template>
  <v-select
    v-model="filters.number"
    :items="tanks"
    :disabled="filters.all || loading"
    :label="`${ $t('Tank') }`"
    item-text="tankDescription"
    item-value="tankNumber"
    class="dover-input"
    chips>
    <template
      slot="selection"
      slot-scope="data">
      <v-chip
        :selected="data.selected"
        :disabled="data.disabled"
        :key="data.item.tankNumber"
        class="v-chip--select-multi "
        @input="data.parent.selectItem(data.item)">
        <v-avatar class="dover-avatar ">{{ data.item.tankNumber }}</v-avatar>
        {{ data.item.tankDescription }}
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: () => []
    },
    tanks: {
      type: Array,
      required: true,
      default: undefined
    },
    filters: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
  })
}
</script>
